import { Color } from "./Color";
import { TextAlignKinds } from "./TextAlignKinds";
import { ITextStyle } from "./ITextStyle";

export class TextStyle {
  constructor(
    public color: Color = new Color("#000000"),
    public textAlign: TextAlignKinds = TextAlignKinds.TopLeft,
    public baseFontSize: number = 9,
    public adjustedFontSize: number = null,
    public fontFamily: string = "ＭＳ ゴシック",
    public lineHeight: number = 1.06,
    public isMultiLine: boolean = true,
  ) {
    this.adjustedFontSize = adjustedFontSize
      ? adjustedFontSize
      : baseFontSize;
  }

  get displayFontSize(): number {
    return (this.adjustedFontSize !== null && this.adjustedFontSize !== undefined)
      ? this.adjustedFontSize
      : this.baseFontSize;
  }

  get isAdjustedFontSize(): boolean {
    return this.adjustedFontSize && this.adjustedFontSize < this.baseFontSize;
  }

  clone(): TextStyle {
    return new TextStyle(
      this.color.clone(),
      this.textAlign,
      this.baseFontSize,
      this.adjustedFontSize,
      this.fontFamily,
      this.lineHeight,
      this.isMultiLine,
    );
  }

  static from(source: ITextStyle): TextStyle {
    if (!source) {
      return null;
    }
    return new TextStyle(
      Color.from(source.color),
      source.textAlign,
      source.baseFontSize,
      source.adjustedFontSize,
      source.fontFamily,
      source.lineHeight,
      source.isMultiLine,
    );
  }

  static to(source: TextStyle): ITextStyle {
    if (!source) {
      return null;
    }
    return {
      color: {
        value: source.color.value,
      },
      textAlign: source.textAlign,
      baseFontSize: source.baseFontSize,
      adjustedFontSize: source.adjustedFontSize,
      fontFamily: source.fontFamily,
      lineHeight: source.lineHeight,
      isMultiLine: source.isMultiLine,
    };
  }
}
